/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditFeedback';

export const FeedbackForm = ({ touched, errors, readOnly }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Feedback Details" showRequiredLegend={!readOnly} />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="first_name"
          >
            <FormLabel required>First Name</FormLabel>
            <Field
              name="first_name"
              as={Form.Control}
              isInvalid={touched.first_name && !!errors.first_name}
              aria-required
            />
            <ErrorMessage name="first_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="last_name"
          >
            <FormLabel required>Last Name</FormLabel>
            <Field
              name="last_name"
              as={Form.Control}
              isInvalid={touched.last_name && !!errors.last_name}
              aria-required
            />
            <ErrorMessage name="last_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="location"
          >
            <FormLabel required>Location</FormLabel>
            <Field
              name="location"
              as={Form.Control}
              isInvalid={touched.location && !!errors.location}
              aria-required
            />
            <ErrorMessage name="location">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="email"
          >
            <FormLabel required>Email</FormLabel>
            <Field
              name="email"
              as={Form.Control}
              isInvalid={touched.email && !!errors.email}
              aria-required
            />
            <ErrorMessage name="email">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="phone_number"
          >
            <FormLabel required>Phone Number</FormLabel>
            <Field
              name="phone_number"
              as={Form.Control}
              isInvalid={touched.phone_number && !!errors.phone_number}
              aria-required
            />
            <ErrorMessage name="phone_number">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="message"
          >
            <FormLabel required>Message</FormLabel>
            <Field
              name="message"
              as={'textarea'}
              className="form-control"
              isInvalid={touched.message && !!errors.message}
              aria-required
            />
            <ErrorMessage name="message">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
